(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lv-lamp-product"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-lv-thumb]');if(!button)return;const section=button.closest('[data-lv-product]');section.querySelectorAll('[data-lv-media]').forEach(media=>{media.hidden=media.dataset.lvMedia!==button.dataset.lvThumb;if(media.hidden)media.querySelectorAll('video').forEach(video=>video.pause());});section.querySelectorAll('[data-lv-thumb]').forEach(thumb=>thumb.setAttribute('aria-current',String(thumb===button)));});
document.addEventListener('change',function(event){if(!event.target.matches('[data-lv-option]'))return;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-mirror-product"]) return;
  try {
    

document.addEventListener('click',function(event){const button=event.target.closest('[data-lv-thumb]');if(!button)return;const section=button.closest('[data-lv-product]');section.querySelectorAll('[data-lv-media]').forEach(media=>{media.hidden=media.dataset.lvMedia!==button.dataset.lvThumb;if(media.hidden)media.querySelectorAll('video').forEach(video=>video.pause());});section.querySelectorAll('[data-lv-thumb]').forEach(thumb=>thumb.setAttribute('aria-current',String(thumb===button)));});

document.addEventListener('change',function(event){if(!event.target.matches('[data-lv-option]'))return;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-product"]) return;
  try {
    document.addEventListener('change',function(e){if(e.target.matches('[data-lv-variant]')){const url=new URL(window.location.href);url.searchParams.set('variant',e.target.value);window.location.assign(url.href);}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lv-rb-product"]) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-lv-thumb]');if(!button)return;const section=button.closest('[data-lv-product]');section.querySelectorAll('[data-lv-media]').forEach(media=>{media.hidden=media.dataset.lvMedia!==button.dataset.lvThumb;if(media.hidden)media.querySelectorAll('video').forEach(video=>video.pause());});section.querySelectorAll('[data-lv-thumb]').forEach(thumb=>thumb.setAttribute('aria-current',String(thumb===button)));});
document.addEventListener('change',function(event){if(!event.target.matches('[data-lv-option]'))return;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);});

  } catch(e) { console.error(e); }
})();
})();
